import { GetSearchResultsDto } from '../dtos/get-search-results.dto'
import { SearchRepository } from '../repositories/search'
import { GetSearchResultsSchema } from '../schemas/get-search-results.schema'

type InjectedDependencies = {
    searchRepository: SearchRepository
}

export class SearchService {
    private readonly _searchRepository: SearchRepository

    constructor({ searchRepository }: InjectedDependencies) {
        this._searchRepository = searchRepository
    }

    public async getSearchResults(dto: Partial<GetSearchResultsDto>) {
        const validatedDto = await GetSearchResultsSchema.safeParseAsync(dto)

        if (!validatedDto.success) {
            console.error(validatedDto)
            return
        }

        return await this._searchRepository.getSearchResultByUrl(
            validatedDto.data,
        )
    }

    public async getSearchResultsAlgolia(query: string) {
        return this._searchRepository.getSearchResultsAlgolia(query)
    }
}
